import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const FullScreenLoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${Variables.colors.complementary};
  opacity: 0.7;
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .dot-flashing {
    position: relative;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${Variables.colors.primary_400};
    color: ${Variables.colors.primary_400};
    animation: dotFlashing 0.8s infinite linear alternate;
    animation-delay: 0.5s;
  }

  .dot-flashing::before,
  .dot-flashing::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }

  .dot-flashing::before {
    width: 16px;
    height: 16px;
    left: calc(-1 * (16px + 8px));
    border-radius: 50%;
    background-color: ${Variables.colors.primary_400};
    color: ${Variables.colors.primary_400};
    animation: dotFlashing 0.8s infinite alternate;
    animation-delay: 0s;
  }

  .dot-flashing::after {
    width: 16px;
    height: 16px;
    left: calc(16px + 8px);
    border-radius: 50%;
    background-color: ${Variables.colors.primary_400};
    color: ${Variables.colors.primary_400};
    animation: dotFlashing 0.8s infinite alternate;
    animation-delay: 0.8s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: ${Variables.colors.primary_400};
    }
    50%,
    100% {
      background-color: ${Variables.colors.primary_050};
    }
  }
`;
